export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden pt-16">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20organic%20shapes%20in%20warm%20coral%20peach%20and%20soft%20sage%20green%20tones%20on%20a%20light%20airy%20background%2C%20modern%20minimalist%20art%20composition%20with%20gentle%20gradients%20and%20subtle%20texture%2C%20sophisticated%20gallery%20wall%20aesthetic%2C%20ethereal%20dreamy%20atmosphere%2C%20editorial%20design%20background&width=1600&height=900&seq=hero-bg-v2-sugargoo&orientation=landscape"
          alt="Sugargoo Spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-16 mt-4 md:mt-0">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-xs text-accent-400"></i>
            </div>
            <span className="text-xs text-background-50 font-medium">Independent Sugargoo Spreadsheet Resource Platform</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            Sugargoo Spreadsheet
            <br />
            <span className="text-primary-300">The Ultimate Resource Hub</span>
            <br />
            <span className="text-background-50/90">For Smart Shopping</span>
          </h1>

          <p className="text-sm md:text-base text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            Find organized Sugargoo Spreadsheet resources, product guides, shipping information and expert buying tips in one powerful platform. Discover the best spreadsheet finds curated by experienced shoppers.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Sugargoo Spreadsheet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-sm"></i>
              </div>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-10">
            {['Updated Resources', 'Beginner Friendly', 'Independent Guide', 'Shopping Education'].map((badge) => (
              <div key={badge} className="flex items-center gap-1.5">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-xs text-accent-400"></i>
                </div>
                <span className="text-xs text-background-50/80 whitespace-nowrap">{badge}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}